import { render } from "./DocuSignTab.vue?vue&type=template&id=1c56b2f8&scoped=true&lang=pug"
import script from "./DocuSignTab.vue?vue&type=script&lang=js"
export * from "./DocuSignTab.vue?vue&type=script&lang=js"

import "./DocuSignTab.vue?vue&type=style&index=0&id=1c56b2f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c56b2f8"]])

export default __exports__